import { ReactNode } from 'react'
import clsx from 'clsx'
import * as styles from './styles.module.css'

export interface SectionProps {
  size?: 'small' | 'large'
  children: ReactNode
}

const Section = ({ size, children }: SectionProps): JSX.Element => (
  <>
    <div
      className={clsx(styles.section, {
        [styles.section__small]: size === 'small',
        [styles.section__large]: size === 'large',
      })}
    >
      {children}
    </div>
  </>
)

export default Section
